const updateImage = {
    data() {
        return {
            imgData: [],
        };
    },
    methods: {
        updateImage(img, userId, oldImg = {}) {
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: "/store-image",
                    method: "POST",
                    data: {
                        img,
                        userId,
                        oldImg,
                    },
                    dataType: "json",
                }).done((response) => {
                    if (response.error === "") {
                        resolve(response.data);
                    }
                }).fail((jqXHR, textStatus) => {
                    this.formSubmited = false;
                    console.log(`Request failed: ${textStatus}`);
                });
            });
        },

        getImgUrlById(id) {
            return this.imgData.find((images) => images.imgId === id)?.imgUrl || "";
        },

        syncStorageForImgData(data) {
            this.imgData = data;
            this.$storage.setStorageSync("imgData", this.imgData);
        },
    },
    mounted() {
        if (this.$storage !== null) {
            this.imgData = this.$storage.getStorageSync("imgData") || [];
        }
    },

};

export default updateImage;
